import React from "react";
import { connect } from "react-redux";

import LookFeatureInfo from "../../lookNavigation/lookMain/lookFeature/lookFeatureInfo";

const GroheFeatureInfo = (props) => {
  const {lookOpened} = props;

  return (
    lookOpened ? (
      <section className="grohe-feature__info">
        <LookFeatureInfo/>
      </section>
    ) : null
  )
};

const mapStateToProps = (store) => {
  const {lookOpened} = store.lookState;
  return {
    lookOpened,
  };
};

export default connect(mapStateToProps)(GroheFeatureInfo);
